import React, {useEffect, useState} from "react";
import {useTheme} from "@mui/material/styles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {useNavigate} from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PrintIcon from "@mui/icons-material/Print";
import {AppBar, Card, Snackbar, Typography, Tooltip} from "@mui/material";
import {PATCH, GET} from "APIclient";
import {useLocation} from "react-router-dom";
import {DataGrid, GridActionsCellItem} from "@mui/x-data-grid";
import {useMaterialUIController} from "context";
import properties from "constants/ApplicationConstants";
import dayjs from "dayjs";
import { formatDesignation } from "constants/ApplicationConstants";
import { formatDate } from "constants/ApplicationConstants";

function CTCHistory(noGutter) {
  const [controller] = useMaterialUIController();
  const {darkMode} = controller;
  const location = useLocation();
  const [usersState, setUsersState] = useState(location.state);
  const theme = useTheme();
  const navigate = useNavigate();
  const [formData, setFormData] = React.useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [snakColor, setSnakColor] = useState("");
  const [snakMessage, setSnakMessage] = useState("");
  const [ctcDetails, setCTCDetails] = useState();
  const viewUrl = `admin/get-salaries/${usersState?.empId}`;
  const [details, setDetails] = useState([]);

  useEffect(() => {
    console.log("The value of id", usersState);
    const url = `admin/get-ctc/${usersState?.empId}`;
    const fetchEmployees = async () => {
      try {
        console.log("inside fetch");
        const response = await GET(url);
        if (response.status === 200 && Array.isArray(response.data.data)) {
          setCTCDetails(response.data.data);
          console.log("The value of res d: ", response.data.data);
        } else {
          setCTCDetails([]);
        }
      } catch (error) {
        console.error("Error fetching employees:", error);
        setCTCDetails([]);
      }
    };
    fetchEmployees();
    console.log("The value of ctc d: ", ctcDetails);
  }, [usersState]);

  const handleClose = () => setOpen(false);

  React.useEffect(() => {
    const view = async () => {
      try {
        const response = await GET(viewUrl);
        const view = response?.data?.data;
        setDetails(view);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    view();
  }, [viewUrl]);

  const columns = [
    {field: "id", headerName: "ID", width: 40, minWidth: 40},
    {
      field: "fromDate",
      headerName: "From Date",
      width: 150,
      minWidth: 100,
      flex: 1,
      renderCell: params => {
        const formattedDate = formatDate(params.value);
        return formattedDate || "N/A";
      }
    },
    {
      field: "toDate",
      headerName: "To Date",
      width: 150,
      minWidth: 100,
      flex: 1,
      renderCell: params => {
        const formattedDate = formatDate(params.value);
        return formattedDate || "N/A";
      }
    },
    {
      field: "salary",
      headerName: "CTC",
      width: 150,
      minWidth: 100,
      flex: 1
    },
    {
      field: "Bonus",
      headerName: "Bonus",
      width: 180,
      minWidth: 100,
      flex: 1
    },
    {
      field: "bonusPayDate",
      headerName: "Bonus Pay Date",
      width: 180,
      minWidth: 100,
      flex: 1,
      renderCell: params => {
        const formattedDate = formatDate(params.value);
        return formattedDate || "N/A";
      }
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 80,
      minWidth: 60,
      renderCell: params => {
        return [
          <GridActionsCellItem
            key={`Print-${params.row}`}
            icon={
              <Tooltip title="Print" arrow>
                <PrintIcon />
              </Tooltip>
            }
            label="print"
            color="success"
            onClick={handleView(params.row)}
          />
        ];
      }
    }
  ];

  const rows =
    ctcDetails && Array.isArray(ctcDetails)
      ? ctcDetails.map((item, index) => ({
          id: item.salaryId || index + 1,
          fromDate: item.fromDate || "-",
          toDate: item.toDate || "-",
          salary: item.salary ? item.salary.toString() : "0",
          Bonus: item.variableAmount ? item.variableAmount.toString() : "0",
          bonusPayDate: item.variablePayDate || "-"
        }))
      : [];

  const handleCloseSnackbar = () => setSnackbar(null);
  const handleView = event => {};

  const formattedDesignation = formatDesignation(details?.designation ?? "-");

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        container
        sx={{
          px: {xs: 1, sm: 2, md: 3},
          py: {xs: 1, sm: 2}
        }}
      >
        <AppBar
          position="static"
          sx={{
            background: "transparent",
            boxShadow: "none",
            width: {xs: "100%", sm: "auto"}
          }}
        >
          <Card sx={{width: "100%"}}>
            <MDBox
              pt={2}
              pb={3}
              px={{xs: 1, sm: 2, md: 4}}
              sx={{
                borderRadius: "5px",
                border: "1px solid #D3D3D3",
                overflowX: "auto"
              }}
            >
              <Typography
                variant="h6"
                color="textPrimary"
                sx={{
                  color: "textPrimary",
                  fontFamily: properties.fontFamily,
                  fontSize: "16px",
                  fontWeight: "bold"
                }}
              >
                Employee Details
              </Typography>

              <MDBox
                component="li"
                display="flex"
                flexDirection="column"
                bgColor={darkMode ? "transparent" : "grey-100"}
                borderRadius="lg"
                p={2}
                mt={1}
              >
                <MDBox width="100%" display="flex" flexDirection="column">
                  <MDTypography
                    variant="h6"
                    fontWeight="medium"
                    pb={2}
                    sx={{
                      color: "textPrimary",
                      fontFamily: properties.fontFamily,
                      fontSize: "16px",
                      fontWeight: "bold"
                    }}
                  >
                    Official Details
                  </MDTypography>

                  {/* Employee Details Grid */}
                  <MDBox
                    display="grid"
                    gridTemplateColumns={{xs: "1fr", sm: "repeat(3, 1fr)"}}
                    gap={2}
                    mb={2}
                  >
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Employee ID :
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.empId : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Joining Date :
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? formatDate(details.joinDate) : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Designation :
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? formatDesignation(details.designation) : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Employee Type :
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.empType : "-"}
                      </MDTypography>
                    </MDBox>
                    <MDBox display="flex" alignItems="center">
                      <MDTypography
                        variant="caption"
                        color="text"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "500", minWidth: "120px"}}
                      >
                        Current CTC :
                      </MDTypography>
                      <MDTypography
                        variant="caption"
                        fontFamily={properties.fontFamily}
                        sx={{fontSize: "12px", fontWeight: "600", minWidth: "120px"}}
                      >
                        {details ? details.salary : "-"}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDBox>

              {/* CTC History Section */}
              <MDBox pt={2}>
                <Typography
                  pb={2}
                  variant="h6"
                  color="textPrimary"
                  sx={{
                    color: "textPrimary",
                    fontFamily: properties.fontFamily,
                    fontSize: "16px",
                    fontWeight: "bold"
                  }}
                >
                  CTC History
                </Typography>
                <MDBox
                  sx={{
                    width: "100%",
                    overflowX: "auto",
                    "& .MuiDataGrid-root": {
                      minWidth: 600
                    }
                  }}
                >
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    pagination={false}
                    hideFooter={rows.length <= 20}
                    hideFooterPagination={true}
                    autoHeight
                    disableColumnMenu
                    sx={{
                      fontFamily: properties.fontFamily,
                      fontSize: "15px",
                      "& .MuiDataGrid-cell": {
                        fontSize: {xs: "0.75rem", sm: "0.875rem"}
                      },
                      "& .MuiDataGrid-columnHeaderTitle": {
                        fontSize: {xs: "0.75rem", sm: "0.875rem"}
                      }
                    }}
                  />
                </MDBox>
              </MDBox>
            </MDBox>
          </Card>
        </AppBar>
      </MDBox>
    </DashboardLayout>
  );
}

export default CTCHistory;
